import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import XHR from "i18next-xhr-backend";

const defaultLng = "zh";

i18n
  .use(LanguageDetector)
  .use(XHR)
  .use(initReactI18next)
  .init({
    backend: {
      loadPath: "/locales/zh.json?2Sep22",
      allowMultiLoading: true,
    },
    defaultLng,
    fallbackLng: "zh",
    whitelist: ["en", "zh"],
    debug: false,
    keySeparator: false,
    interpolation: {
      escapeValue: false,
    },
    react: {
      useSuspense: true,
    },
    initImmediate: false,
  });

export default i18n;
